import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import MainLayout from "../layouts/MainLayout";
import ProtectedRoute from "../auth/ProtectedRoute";
import { ROLES, ROUTES } from "../constants/routes";
import { Login, ForgotPassword, Dashboard, Home, AddSchool, AddSchoolPanel } from "./LazyComponents";
import { Suspense } from "react";
import Helpdesk from "../pages/HelpDesk/HelpdeskNew";
import CreateAdmin from "../pages/Admin/CreateAdmin";
import ForgotPasswordPage from "../pages/Auth/ForgotPassword/ForgotPasswordPage";
import GroupList from "../pages/GroupList/GroupList";
import SchoolOnBoarding from "../pages/SchoolOnboarding/SchoolOnboarding";

export default function AppRoutes() {

  return (
    <Suspense>
    <Routes>
      <Route path={ROUTES.ADMINSIGNIN} element={<Login />} />
      <Route path={ROUTES.ADMINFORGOTPASSWORD} element={<ForgotPassword />} />
      <Route element={<ProtectedRoute allowedRoles={[ROLES.ADMIN]} />}>
        <Route path={ROUTES.HOME} element={<Dashboard />} />
        <Route path={ROUTES.MAINHOME} element={<Home />} />
        <Route path={ROUTES.SCHOOLMANAGEMENT} element={<AddSchoolPanel />} />
        <Route path={ROUTES.ADMINMANAGEMENT} element={<CreateAdmin />} />
        <Route path={ROUTES.HELPDESK} element={<Helpdesk />} />
        <Route path={ROUTES.GROUPLIST} element={<GroupList/>} />
        <Route path={ROUTES.SCHOOLONBOARDING} element={<SchoolOnBoarding/>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Suspense>
  );
}
